define('views/files/Podio.Views.Files.GenericFileItem',['require','translate','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.Modal','lib/Podio.UI.FlashMessage'],function(require) {

  var t = require('translate');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var modal = require('lib/Podio.UI.Modal');
  var flashMessage = require('lib/Podio.UI.FlashMessage');

  return ViewPodioBase.extend({
    events: {
      'click .delete-file': 'deleteFile'
    },

    deleteFile: function() {
      var self = this;

      modal.showConfirm(t('Delete file #space-files'), t('Are you sure you want to delete this file? #space-files'), null, {}, function() {
        var fileName = self.model.get('name') || '';
        self.model.destroy({
          success: function() {
            flashMessage.show(t('Your file {0} has been successfully deleted #space-files').format(fileName));
          }
        });
        $(self.el).remove();
      });

      return false;
    },

    getIconForContext: function() {
      var icon;

      switch (this.model.get('context').type) {
      case 'space':
        icon = 'sprite-icon icon-space';
        break;
      case 'item':
        icon = 'sprite-icon app-icon-16 icon-{0}'.format(this.model.get('context').data.app.icon_id);
        break;
      case 'status':
        icon = 'sprite-icon icon-status';
        break;
      case 'task':
        icon = 'sprite-icon icon-16-task';
        break;
      case 'file':
        icon = 'sprite-icon icon-16-file';
        break;
      }

      return icon;
    }
  });

});

